import { deleteUser } from './deleteUserSlice';
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import useNotification from '../notification/useNotification'
import { useSpinner } from '../../customHooks';
import { userList } from '../../pages/users/listUserSlice';
import { selector as deleteUserApi } from './deleteUserSlice';
import { IDeleteUserPayload } from '../../common/types/userTypes';
import { isSuccessResponse } from '../../common/utils';

export const useDeleteModal = (id?:string) => {
  const [userId, setUserId] = useState<string>(id?id:'');
  const [show, setShow] = useState(false);
  
  const dispatch: any = useDispatch();
  const deleteUserResponse = useSelector(deleteUserApi);

  useSpinner(deleteUserResponse.status);
  const handleClose = () => setShow(false);
  
  const handleShow = () =>{
    setShow(true);
  }
  
  const setPayload = () => {
    const deleteUserPayload:IDeleteUserPayload = { userId: userId };
    return deleteUserPayload;
  }

  const { showSuccessNotification, showWarningNotification } = useNotification();
  const handleDeleteButtonClick = () => {
    const deleteUserPayload = setPayload();
    dispatch(deleteUser(deleteUserPayload)).then((response: any) => {
      if (isSuccessResponse(response.payload)) {
          dispatch(userList());
          showSuccessNotification(response.payload.message);
      }
      else {
          showWarningNotification(response.payload.response.data.message);
      }
    });
    setUserId('');
    setShow(false);
  };

  return {
      show,
      setShow,
      handleDeleteButtonClick,
      setUserId,
      handleClose,
      handleShow
  };
}